<template>
  <div v-html="message" />
</template>


<script>
export default {
  name: "ModalMessage",
  props: {
    message: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>